var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$currentUser.role != "admin" && _vm.$currentUser.role != "account"
        ? _c("div", { staticClass: "main-content bg-white" }, [
            _c("span", { staticClass: "alert-danger" }, [
              _vm._v("У вас нет доступа к этой странице.")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$currentUser.role == "admin" || _vm.$currentUser.role == "account"
        ? _c("div", { staticClass: "main-content bg-white" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                {
                  key: _vm.dateRange,
                  staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
                },
                [
                  _vm.isXl
                    ? _c(
                        "b-button-group",
                        { staticClass: "datePickerXl" },
                        [
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              "locale-data": _vm.dateRangeLocalFormat,
                              opens: "right",
                              ranges: _vm.dateRanges
                            },
                            on: {
                              update: function($event) {
                                return _vm.selectRange($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function(picker) {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.startDate
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.endDate
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              754668195
                            ),
                            model: {
                              value: _vm.range,
                              callback: function($$v) {
                                _vm.range = $$v
                              },
                              expression: "range"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { attrs: { size: "sm", variant: "primary" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-calendar-check-o"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXl
                    ? _c(
                        "b-input-group",
                        { key: _vm.dateRange },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c("datepicker", {
                                staticClass: "date dateLeft",
                                attrs: {
                                  "input-class": "form-control dateFrom",
                                  size: "sm",
                                  "monday-first": "",
                                  language: _vm.ru,
                                  placeholder: "С:"
                                },
                                model: {
                                  value: _vm.range.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "startDate", $$v)
                                  },
                                  expression: "range.startDate"
                                }
                              }),
                              _vm._v(" "),
                              _c("datepicker", {
                                staticClass: "date dateRight",
                                attrs: {
                                  "input-class": "form-control dateTo",
                                  "monday-first": "",
                                  size: "sm",
                                  language: _vm.ru,
                                  placeholder: "По:"
                                },
                                model: {
                                  value: _vm.range.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "endDate", $$v)
                                  },
                                  expression: "range.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        options: _vm.selectOffers,
                        filter: _vm.filterOffers,
                        required: "",
                        label: "title",
                        placeholder: "Оффер",
                        multiple: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function(option) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(option.id) +
                                      ") " +
                                      _vm._s(option.title)
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1477995661
                      ),
                      model: {
                        value: _vm.search,
                        callback: function($$v) {
                          _vm.search = $$v
                        },
                        expression: "search"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        label: "name",
                        placeholder: "Аккаунт",
                        options: _vm.accountManagers,
                        reduce: function(accountManager) {
                          return accountManager.id
                        },
                        multiple: ""
                      },
                      model: {
                        value: _vm.account,
                        callback: function($$v) {
                          _vm.account = $$v
                        },
                        expression: "account"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        id: "source_group",
                        label: "name",
                        placeholder: "Группа источника",
                        options: _vm.sourceGroups,
                        reduce: function(sourceGroup) {
                          return sourceGroup.id
                        },
                        multiple: ""
                      },
                      model: {
                        value: _vm.selectedSourceGroups,
                        callback: function($$v) {
                          _vm.selectedSourceGroups = $$v
                        },
                        expression: "selectedSourceGroups"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.$currentUser.role == "admin" ||
              _vm.$currentUser.role == "leader"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            label: "name",
                            options: _vm.users,
                            filter: _vm.filterBuyers,
                            required: "",
                            placeholder: "Медиабайер",
                            multiple: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(option.name) +
                                          " (" +
                                          _vm._s(option.network_partner_id) +
                                          ")"
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1056032186
                          ),
                          model: {
                            value: _vm.user,
                            callback: function($$v) {
                              _vm.user = $$v
                            },
                            expression: "user"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [_vm._v("Совпадений не найдено.")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c("v-select", {
                    attrs: {
                      options: _vm.types,
                      placeholder: "Тип",
                      clearable: false,
                      searchable: false,
                      multiple: ""
                    },
                    model: {
                      value: _vm.type,
                      callback: function($$v) {
                        _vm.type = $$v
                      },
                      expression: "type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        placeholder: "Сейл",
                        label: "name",
                        options: _vm.salesManagers,
                        reduce: function(manager) {
                          return manager.id
                        },
                        required: "",
                        multiple: ""
                      },
                      model: {
                        value: _vm.selectedSalesManagers,
                        callback: function($$v) {
                          _vm.selectedSalesManagers = $$v
                        },
                        expression: "selectedSalesManagers"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        options: _vm.advertisers,
                        placeholder: "Рекламодатель",
                        reduce: function(advertiser) {
                          return advertiser.value
                        },
                        required: "",
                        multiple: ""
                      },
                      model: {
                        value: _vm.selectedAdvertisers,
                        callback: function($$v) {
                          _vm.selectedAdvertisers = $$v
                        },
                        expression: "selectedAdvertisers"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton"
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("div"),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton",
                              staticStyle: {
                                "margin-right": "4px",
                                "border-top-left-radius": "0.2rem",
                                "border-bottom-left-radius": "0.2rem"
                              },
                              attrs: {
                                size: "sm",
                                text: "Search",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getConversions(
                                    1,
                                    {
                                      sortBy: _vm.sortBy,
                                      sortDesc: _vm.sortDesc
                                    },
                                    _vm.search,
                                    true
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            Применить\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton",
                              attrs: { size: "sm", variant: "outline-danger" },
                              on: { click: _vm.resetFilters }
                            },
                            [_vm._v("Очистить\n                            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col-lg-12" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "info", size: "sm" },
                      on: { click: _vm.openDataUploadModal }
                    },
                    [
                      _vm._v("\n                   Загрузить xls "),
                      _c("i", { staticClass: "icon-fa icon-fa-upload" })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    { attrs: { variant: "warning", size: "sm" } },
                    [
                      _c("a", { attrs: { href: _vm.getExcelParamsString() } }, [
                        _vm._v("\n                        Выгрузить xls "),
                        _c("i", { staticClass: "icon-fa icon-fa-upload" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "info", size: "sm" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.openBuyersTable()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    Список байеров\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isSelectAll
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "warning", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.selectAll()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Выделить все\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSelectAll
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "info", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.diselectAll()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Снять выделение\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.editSelected()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                Редактировать выделенное\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.deleteSelected()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Удалить выделенное\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-12" },
                [
                  _c(
                    "b-alert",
                    {
                      attrs: { variant: "danger", dismissible: "" },
                      model: {
                        value: _vm.showDismissibleAlert,
                        callback: function($$v) {
                          _vm.showDismissibleAlert = $$v
                        },
                        expression: "showDismissibleAlert"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.alertText))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      attrs: { variant: "success", dismissible: "" },
                      model: {
                        value: _vm.showSuccessAlert,
                        callback: function($$v) {
                          _vm.showSuccessAlert = $$v
                        },
                        expression: "showSuccessAlert"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.successAlertText))])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                !_vm.isMobile
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            small: "",
                            busy: _vm.isBusy,
                            items: _vm.conversions,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getConversions(1, $event, _vm.search)
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "div",
                                      {},
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-warning",
                                            attrs: { size: "sm" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.edit(row)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-edit"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(source_group_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.source_group_name))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(buyer_name)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(row.item.buyer_name) +
                                          " (" +
                                          _vm._s(row.item.buyer_id) +
                                          ")"
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(select)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "div",
                                      {},
                                      [
                                        _c("b-form-checkbox", {
                                          on: {
                                            change: function($event) {
                                              return _vm.selectConversion(
                                                $event,
                                                row.item.id
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.selectedConversions[
                                                row.item.id
                                              ],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedConversions,
                                                row.item.id,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedConversions[row.item.id]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "bottom-row",
                                fn: function(data) {
                                  return [
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("b", [_vm._v("Total:")]),
                                        _vm._v(" "),
                                        _vm._l(_vm.total_amount, function(
                                          field,
                                          i
                                        ) {
                                          return _c("div", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(field.currency) + ": "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(field.amount))
                                            ])
                                          ])
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td"),
                                    _c("td"),
                                    _c("td")
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1356546476
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMobile
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            stacked: "",
                            small: "",
                            busy: _vm.isBusy,
                            items: _vm.conversions,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getConversions(1, $event, _vm.search)
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "div",
                                      {},
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-warning",
                                            attrs: { size: "sm" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.edit(row)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-edit"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(source_group_name)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.source_group_name))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(select)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "div",
                                      {},
                                      [
                                        _c("b-form-checkbox", {
                                          on: {
                                            change: function($event) {
                                              return _vm.selectConversion(
                                                $event,
                                                row.item.id
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.selectedConversions[
                                                row.item.id
                                              ],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedConversions,
                                                row.item.id,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedConversions[row.item.id]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "bottom-row",
                                fn: function(data) {
                                  return [
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("b", [_vm._v("Total:")]),
                                        _vm._v(" "),
                                        _vm._l(_vm.total_amount, function(
                                          field,
                                          i
                                        ) {
                                          return _c("div", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(field.currency) + ": "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(field.amount))
                                            ])
                                          ])
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td"),
                                    _c("td"),
                                    _c("td")
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1179335401
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-5" }, [
                _c(
                  "div",
                  { attrs: { role: "status", "aria-live": "polite" } },
                  [_vm._v("Всего записей: " + _vm._s(_vm.pager.total))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-7" }, [
                _c("div", { staticClass: "float-right" }, [
                  _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
                    _c(
                      "ul",
                      { staticClass: "pagination justify-content-center" },
                      [
                        _c("b-pagination", {
                          attrs: {
                            size: "sm",
                            "total-rows": _vm.pager.total,
                            "per-page": _vm.pager.per_page
                          },
                          on: {
                            change: function($event) {
                              return _vm.getConversions(
                                $event,
                                { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                                _vm.search
                              )
                            }
                          },
                          model: {
                            value: _vm.pager.current_page,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "current_page", $$v)
                            },
                            expression: "pager.current_page"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "EditConversionModal",
          attrs: {
            "no-close-on-backdrop": true,
            "no-enforce-focus": true,
            "no-close-on-esc": true,
            id: "EditConversionModal",
            size: "md",
            title: "Редактировать конверсию",
            "hide-footer": ""
          },
          on: {
            hide: function($event) {
              return _vm.getConversions()
            }
          }
        },
        [
          _c("EditConversionModal", {
            attrs: { conversion: _vm.selectedConversion }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "MassEditConversionsModal",
          attrs: {
            "no-close-on-backdrop": true,
            "no-enforce-focus": true,
            "no-close-on-esc": true,
            id: "EditConversionModal",
            size: "md",
            title: "Редактировать конверсии",
            "hide-footer": ""
          },
          on: {
            hide: function($event) {
              return _vm.getConversions()
            }
          }
        },
        [
          _c("MassEditConversionsModal", {
            attrs: { conversions: _vm.selectedConversions }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "BuyersTableModal",
          attrs: {
            "no-close-on-backdrop": true,
            "no-enforce-focus": true,
            "no-close-on-esc": true,
            id: "BuyersTableModal",
            size: "md",
            title: "Список байеров",
            "hide-footer": ""
          }
        },
        [_c("BuyersTableModal")],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "uploadDataModal",
          attrs: {
            id: "uploadDataModal",
            "ok-disabled": !Boolean(_vm.uploadDataModal.file),
            "ok-title": "Загрузить",
            "cancel-title": "Отмена",
            title: "Загрузить данные"
          },
          on: {
            ok: _vm.uploadData,
            hidden: function($event) {
              _vm.uploadDataModal.file = null
            }
          }
        },
        [
          _vm._l(_vm.uploadDataModal.errors, function(error) {
            return _c("span", { staticClass: "alert-danger" }, [
              _vm._v(_vm._s(error))
            ])
          }),
          _vm._v(" "),
          _c(
            "form",
            { staticClass: "mt-2" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Выберите файл или перенесите сюда" } },
                [
                  _c("b-form-file", {
                    attrs: {
                      state: Boolean(_vm.uploadDataModal.file),
                      accept: ".xlsx, .xls",
                      size: "sm",
                      placeholder: "Файл не выбран",
                      "drop-placeholder": "Drop file here..."
                    },
                    model: {
                      value: _vm.uploadDataModal.file,
                      callback: function($$v) {
                        _vm.$set(_vm.uploadDataModal, "file", $$v)
                      },
                      expression: "uploadDataModal.file"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Конверсии")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f49e7eb0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f49e7eb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/Conversions.vue
// module id = 1070
// module chunks = 0